import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const FeeStructure = () => {
    useEffect(() => {
        document.title = 'Fee Structure -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Fee Structure</h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Academic</li>
                            <li>|</li>
                            <li> Fee Structure </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                      <h1 className="head1"> Re Admission</h1>
                      <div class="table-responsive"> 
                      <table class="table table-striped table-bordered">
                       <tbody> 
                          <tr> 
                          <td>Class</td>
                          <td>First Quarter (April To June)</td>
                          <td>Second Quarter (July To September)</td>
                          <td>Third Quarter (October To December)</td>
                          <td>Fourth Quarter (January  To March)</td>
                               </tr>
                                <tr><td>L.K.G &  U.K.G</td>
                                  <td>9800/-</td>
                              <td>7800/-</td>
                              <td>8800/-</td>
                              <td>7800/-</td>
                          </tr> <tr><td>1 &  2</td>
                                  <td>10100/-</td>
                              <td>8100/-</td>
                              <td>9100/-</td>
                              <td>8100/-</td>
                          </tr> <tr><td>3 TO 5</td>
                                  <td>10800/-</td>
                              <td>8700/-</td>
                              <td>9800/-</td>
                              <td>8700/-</td>
                          </tr> <tr><td>6 TO 8</td>
                                  <td>11700/-</td>
                              <td>9600/-</td>
                              <td>10700/-</td>
                              <td>9600/-</td>
                          </tr> <tr><td>9 &  10</td>
                                  <td>12000/-</td>
                              <td>9900/-</td>
                              <td>11000/-</td>
                              <td>9900/-</td>
                               
                          </tr> <tr><td>11 &  12</td>
                                  <td>12600/-</td>
                              <td>10500/-</td>
                              <td>11600/-</td>
                              <td>10500/-</td>
                          </tr> 
                      </tbody>
                       </table>
                  </div>
                  <h1 className="head1"> New Admission</h1>
                  <div class="table-responsive"> 
                        <table class="table table-striped table-bordered">
                        <tbody>
                                        <tr class="table-head">
                                        <td>Class</td>
                                        <td>First Quarter (April To June)</td>
                                        <td>Second Quarter (July To September)</td>
                                        <td>Third Quarter (October To December)</td>
                                        <td>Fourth Quarter (January  To March)</td>
                                        </tr>

                    <tr><td>PLAY GROUP, L.K.G & U.K.G</td><td>12800/-</td><td>7800/-</td><td>8800/-</td><td>7800/-</td></tr>
                    <tr><td>1 & 2</td><td>13100/-</td><td>8100/-</td><td>9100/-</td><td>8100/-</td></tr>
                    <tr><td>3 TO 5</td><td>13800/-</td><td>8700/-</td><td>9800/-</td><td>8700/-</td> </tr>
                    <tr><td>6 TO 8</td><td>15200/-</td><td>9600/-</td><td>10700/-</td><td>9600/-</td> </tr>
                    <tr><td>9 & 10</td><td>-</td><td>9900/-</td><td>11000/-</td><td>9900/-</td></tr>
                    <tr><td>11 & 12</td><td>-</td><td>10500/-</td><td>11600/-</td><td>10500/-</td></tr>

                                    </tbody>
                        </table>
                    </div>
                     </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default FeeStructure